import { computed } from 'vue';
import { ShortCodeService } from '@ht/lib-plural-vue';

export default function useDynamicButtons(buttons) {
  const dynamicButtons = computed(() => {
    if (Array.isArray(buttons)) {
      return buttons.map(({ button, next }) => ({
        button: {
          ...button,
          text: new ShortCodeService(button.text || '')
            .matchAttributes()
            .getValue(),
          variations: button.variations.map((v) => new ShortCodeService(v || '')
            .matchAttributes()
            .getValue()),
        },
        next,
      }));
    }
    return [];
  });

  return dynamicButtons;
}
